
<div class="mx-xl-4 mx-lg-2 mx-md-2 pb-5">
  <div class="d-flex flex-column">
    <div v-if="aide.lienYoutube" class="mb-3">
      <div class="content-inner youtube-container embed-responsive embed-responsive-16by9">
        <iframe
          :data-src="aide.lienYoutube"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        >
        </iframe>

        <!-- Message & "I accept" button -->

        <div class="video-consent-overlay">
          <div class="scrollable-section">
            <div class="logo">
              <svg-icon icon-name="youtube"></svg-icon>
            </div>
            <div class="video-consent-overlay-text">
              <p>
                {{ $t('youtubeVideoConsent.texte') }}
              </p>
            </div>
          </div>
          <button class="video-consent-overlay-accept-button">
            {{ $t('youtubeVideoConsent.texteBoutonAccept') }}
          </button>
        </div>
      </div>
    </div>
    <div>
      <div v-for="(questionRep, index) in aide.listeQuestionsReponses" :key="questionRep['id']">
        <div class="d-flex flex-column">
          <ZoneEscamotable :content="getContentZoneEscamotable(questionRep)" />
          <Separateur v-if="index != listeQuestionsReponses.length - 1" class="w-100 mt-1" />
        </div>
      </div>
      <div>
        <!-- Empêcher que l'appel REST se fasse quand l'aide est fermée -->
        <Heritage v-if="aide.isAideActif" :content="contentHeritage" />
        <!-- TODO: corriger problème accessibilité: https://css-tricks.com/accessible-svg-icons/ -->
        <!-- eslint-disable-next-line vuejs-accessibility/anchor-has-content -->
        <!-- a v-bind="bindUrlNousJoindre" class="btnVide py-1">
          <svg-icon class="iconTaille mr-2 color-filling" icon-name="ic-tel"></svg-icon>
          <label class="sr-only">{{ $t("contact") }}</label>
        </a-->
      </div>
    </div>
  </div>
</div>
